module.exports = __webpack_public_path__ + "static/media/friendFamilyBannerDiscountIcon.8e4face3.svg";